module.exports = __webpack_public_path__ + "static/media/ClaroVideoSVG.3a65743c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ClaroVideoSVG.svg
// module id = 2430
// module chunks = 0